import React from "react"

export function isValidEmailTextPattern(emailText) {
    const check = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    return check.test(emailText);
}

export function isValidPasswordPattern(passwordText) {
    return /.{8,}/.test(passwordText)
        && /\d/.test(passwordText)
        && /[A-Z]/.test(passwordText)
        && /[@$!%*?^&#]/.test(passwordText)
}

export function validateCollaborator(ownerEmailAddress, newCollaboratorEmailAddress, existingCollaborators) {
    if (isValidEmailTextPattern(newCollaboratorEmailAddress)) {
        if (ownerEmailAddress === newCollaboratorEmailAddress) {
            return false
        } else return newCollaboratorEmailAddress !== existingCollaborators;
    } else return false
}

export function detectHyperlinkText(str) {
    const regex = /(\bhttps?:\/\/\S+|\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}|\b(?:[-+() ]*\d){10,13}\b)/g;

    const parts = str.split(regex);

    return parts.map((part, i) => {
        if (/^\bhttps?:\/\/\S+$/.test(part)) {
            return (
                <a key={i} href={part} target="_blank" rel="noopener noreferrer">
                    {part}
                </a>
            );
        } else if (/^\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b$/.test(part)) {
            return (
                <a key={i} href={`mailto:${part}`}>
                    {part}
                </a>
            );
        } else if (/^(?:[-+() ]*\d){10,13}$/.test(part)) {
            return (
                <a key={i} href={`tel:${part}`}>
                    {part}
                </a>
            );
        } else {
            return <React.Fragment key={i}>{part}</React.Fragment>;
        }
    });
}

